import React, { FunctionComponent } from 'react'
import styles from './index.module.scss'

type Props = {
    className?: string
    name?: string
    value: string
    onChange: (value: string) => void
    autofocus?: boolean
    placeholder?: string
    disabled?: boolean
    onBlur?: () => void
    onFocus?: () => void
    onKeyEnter?: () => void
}

export const Input: FunctionComponent<Props> = (props) => {
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(e.target.value)
    }
    const onKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            props.onKeyEnter && props.onKeyEnter()
        }
    }
    return (
        <input className={props.className || ''} name={props.name} value={props.value}
            placeholder={props.placeholder}
            autoFocus={props.autofocus === true}
            onChange={onChange} disabled={props.disabled}
            onBlur={props.onBlur}
            onFocus={props.onFocus}
            onKeyUp={onKeyUp}
        />
    )
}


export const Password: FunctionComponent<Props> = (props) => {
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(e.target.value)
    }
    return (
        <input className={styles.class} value={props.value} onChange={onChange} type='password' disabled={props.disabled}/>
    )
}